
import React from 'react';
import { Bell, Mail, Info, AlertTriangle } from 'lucide-react';

export const NotificationsPage: React.FC = () => {
    const notifications = [
        { id: 1, type: 'info', title: 'System Update', message: 'The platform has been updated to version 2.4.0.', time: '2 hours ago' },
        { id: 2, type: 'warning', title: 'High Usage', message: 'Workspace "Sales Team" is approaching its token limit.', time: '5 hours ago' },
        { id: 3, type: 'mail', title: 'New Member', message: 'Sarah Smith has joined the Recruitment Management workspace.', time: '1 day ago' },
    ];

    const getIcon = (type: string) => {
        switch (type) {
            case 'info': return <Info size={18} className="text-blue-500" />;
            case 'warning': return <AlertTriangle size={18} className="text-amber-500" />;
            case 'mail': return <Mail size={18} className="text-emerald-500" />;
            default: return <Bell size={18} />;
        }
    };

    return (
        <div className="max-w-4xl mx-auto space-y-8">
            <div>
                <h1 className="text-2xl font-bold text-slate-900 dark:text-white">Notifications</h1>
                <p className="text-slate-500 dark:text-slate-400 text-sm mt-1">Manage your alerts and view platform activity logs.</p>
            </div>

            <div className="space-y-4">
                {notifications.map((n) => (
                    <div key={n.id} className="bg-white dark:bg-slate-800 p-6 rounded-3xl border border-slate-200 dark:border-slate-700 shadow-sm flex gap-4 transition-colors">
                        <div className="mt-1 p-2 bg-slate-50 dark:bg-slate-900/50 rounded-xl">
                            {getIcon(n.type)}
                        </div>
                        <div className="flex-1">
                            <div className="flex items-center justify-between mb-1">
                                <h3 className="font-bold text-slate-900 dark:text-white">{n.title}</h3>
                                <span className="text-xs text-slate-400 font-medium">{n.time}</span>
                            </div>
                            <p className="text-sm text-slate-500 leading-relaxed">{n.message}</p>
                        </div>
                    </div>
                ))}
            </div>


        </div>
    );
};

export default NotificationsPage;
